import { presaVisioneActions } from "../../../redux/PresaVisione";
import { UserService } from "../../../services/UserService";
import { useDispatch } from "react-redux";
import { useContext } from "react";
import ToastContext from "../../../contexts/toast";

export default function PresaVisione() {
  const dispatch = useDispatch();

  const toastContext = useContext(ToastContext);

  const userService = new UserService();

  const setPresaVisione = () => {
    userService.setPresaVisione().then(() => {
      dispatch(presaVisioneActions.setPresaVisione({ presaVisione: true }));
      toastContext.success("Presa visione aggiornata");
    });
  };

  return (
    <div className="rtds-container rtds-my-12 ">
      <div className="rtds-mb-6 ">
        <h1 className="rtds-text-2xl rtds-font-bold">Informativa sul trattamento dei dati</h1>
      </div>

      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
          Proseguendo con l’accesso all’applicativo della misura Libri Gratis di Regione Toscana, confermo di aver preso visione dell’informativa sul 
          trattamento dei dati personali di cui al regolamento (UE) 2026/679, 
          pubblicata sul sito istituzionale di Regione Toscana nella sezione dedicata al bando Libri Gratis (<a target="_blank" rel="noopener noreferrer" className="rtds-action-link
      rtds-action-link--has-icon" href="https://www.regione.toscana.it/librigratis">www.regione.toscana.it/librigratis
      <svg className="rtds-icon rtds-fill-current rtds-h-6 rtds-w-6" aria-hidden="true" focusable="false" role="img">
        <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--arrow-small-right`} />
    </svg>
      </a>).
          </p>
     
        </div>
        <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:rtds-justify-end rtds-justify-center">
          <div className="rtds-form-actions">
            <div
              className="rtds-inline-flex rtds-gap-1"
              role="group"
              aria-label="Azioni"
            >
              <button
                type="button"
                className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-left rtds-group/button"
                onClick={() => setPresaVisione()}
              >
                Conferma presa visione
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
